module.exports = __webpack_public_path__ + "img/pdf.63dcc590.svg";